import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	title: {
		id: 'eoc-schedule.ui.list.revert-override.title',
		defaultMessage: 'Remove override?',
		description: 'Title for revert override modal.',
	},
	explanation: {
		id: 'eoc-schedule.ui.list.revert-override.explanation',
		defaultMessage:
			'This will remove the override and restore the previous participant for the selected shift.',
		description: 'Explanation for revert override implications.',
	},
});

export { messages };
